import { render, staticRenderFns } from "./tmc-icon.vue?vue&type=template&id=3643330b&scoped=true"
import script from "./tmc-icon.vue?vue&type=script&lang=js"
export * from "./tmc-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643330b",
  null
  
)

export default component.exports